import React, { useEffect, memo, useState } from 'react';
import { parseType } from '../../utils/parseType';
import validator from 'validator';
import {
  Table,
  Pagination,
  Button,
  Radio,
  Typography,
  Space,
  Dropdown,
  Menu,
  Image,
  Tabs,
} from 'antd';
import { useSPQLColumns } from './useSPQLColumns';
import { useGetScanData } from './useGetScanData';
import styled from 'styled-components';
import {
  SPQLTableHeader,
  MIN_SELECTED_COLUMNS,
  MAX_SELECTED_COLUMNS,
} from './components/SPQLTableHeader';
import { useSelector } from 'react-redux';
import {
  getSPQLSelectedColumns,
  getSPQLLoading,
  getSPQLQuery,
  getSPQLSorting,
  getSPQLCurrentPage,
  getSPQLFieldsMetadata,
} from '../../redux/selectors/deep_scan';
import { STATUS } from '../../redux/constants';
import { ColumnTitle } from '../ColumnTitle';
import styles from './spql-results-table.module.sass';
import Icon, { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import {
  showNotification,
  infoNotification,
  warningNotification,
} from '../Notifications';
import { ReactComponent as copy_icon } from '../../assets/icons/Copy.svg';
import { ReactComponent as no_data_icon } from '../../assets/icons/no_results.svg';
import LoadingSilentPush from '../LoadingSilentPush';
import PivotMatrix from '../PivotOptions/PivotMatrix';

const { Title, Text } = Typography;

const SPCheckbox = styled.div`
  .ant-table {
    overflow-y: hidden;
  }
  .ant-table-cell-scrollbar:not([rowspan]) {
    box-shadow: none;
  }
  .ant-table-measure-row td {
    padding: 0 !important;
  }
  .ant-table-cell-fix-right {
    background: #1c3138 !important;
  }
  .ant-table-cell-fix-left {
    background: #1c3138 !important;
  }
  .ant-table-thead {
    height: 48px;
  }
  th.ant-table-cell {
    background: #1c3138;
  }
  tr.ant-table-expanded-row > td.ant-table-cell {
    padding: 0 !important;
  }
  .ant-table-expanded-row-fixed {
    padding: 16px 0 !important;
  }
`;

const SPInnerTable = styled.div`
  thead.ant-table-thead > tr > th {
    background: #0b171b;
  }
  .ant-table {
    border: 0;
  }
  .ant-table-tbody > tr > td {
    word-break: initial;
    word-wrap: break-word;
  }
`;

function AttachColumn(props) {
  return (
    <div
      onClick={props.onClick}
      style={{
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 16,
        height: 16,
        borderRadius: 4,
        background: '#6ABE39',
      }}
    >
      <PlusOutlined style={{ color: 'white', fontSize: 12, padding: 2 }} />
    </div>
  );
}

function RemoveColumn(props) {
  return (
    <div
      onClick={props.onClick}
      style={{
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 16,
        height: 16,
        borderRadius: 4,
        background: '#b42929',
      }}
    >
      <MinusOutlined style={{ color: 'white', fontSize: 12, padding: 2 }} />
    </div>
  );
}

function SPQLPivotingToExploreMenu({ iocType, value, ...props }) {
  const [selectedAdvancedAnswer, setSelectedAdvancedAnswer] = useState(null);
  const [selectedAdvancedQuery, setSelectedAdvancedQuery] = useState(null);

  const onChangeAdvancedAnswer = (e) => {
    setSelectedAdvancedAnswer(e.target.value);
    setSelectedAdvancedQuery(null);
  };
  const onChangeAdvancedQuery = (e) => {
    setSelectedAdvancedQuery(e.target.value);
    setSelectedAdvancedAnswer(null);
  };
  const defaultOptions = [
    {
      any: true,
      anyipv4: true,
      a: true,
      aaaa: true,
      cname: true,
      mx: true,
      ns: true,
      ptr4: true,
      ptr6: true,
      txt: true,
      soa: true,
      anyipv6: true,
    },
    {
      a: true,
      aaaa: true,
      ptr4: true,
      ptr6: true,
      cname: true,
      mx: true,
      ns: true,
      txt: true,
      soa: true,
      mxhash: true,
      nshash: true,
      soahash: true,
      txthash: true,
    },
  ];

  let objectType = iocType;
  if (objectType === 'domain') {
    objectType = 'host';
  }

  let queryType = 'query';
  if (objectType === 'ipv4') {
    queryType = 'answer';
  }

  const options = PivotMatrix(objectType, queryType, defaultOptions);

  const handlePADNSLookup = () => {
    window.open(
      `/explore-result?name=${
        selectedAdvancedAnswer === 'SOA' || selectedAdvancedAnswer === 'TXT'
          ? value
          : value
              ?.replaceAll('[', '')
              ?.replaceAll(']', '')
              ?.trim()
              ?.replaceAll(' ', '')
              ?.replaceAll('./', '.')
      }&queryType=${
        selectedAdvancedQuery
          ? 'query'
          : selectedAdvancedAnswer
          ? 'answer'
          : 'query'
      }&type=${
        selectedAdvancedQuery !== null
          ? selectedAdvancedQuery
          : selectedAdvancedAnswer !== null
          ? selectedAdvancedAnswer
          : validator.isIP(value)
          ? 'ANYIPV4'
          : 'any'
      }`,
      '_blank',
      'noreferrer',
    );
  };
  const handleEnrichment = () => {
    let type = iocType;
    if (type === 'ipv4') {
      type = 'ip';
    }
    window.open(
      `/enrichment?name=${value}&type=${type}`,
      '_blank',
      'noreferrer',
    );
  };

  return (
    <div style={{ padding: 16, width: 450 }} className={styles.pivotOptions}>
      <div style={{ display: 'flex', alignItems: 'center', paddingBottom: 8 }}>
        <Button
          onClick={handleEnrichment}
          disabled={selectedAdvancedAnswer || selectedAdvancedQuery}
          type="primary"
          style={{ marginRight: 8 }}
        >
          Enrich
        </Button>
        <Button
          onClick={handlePADNSLookup}
          disabled={!selectedAdvancedAnswer && !selectedAdvancedQuery}
          type="primary"
        >
          Lookup PADNS
        </Button>
      </div>
      <Text>Choose a forward or reverse lookup to apply to the data</Text>
      <Title level={4} className={styles['sub-title']}>
        Query
      </Title>
      <Radio.Group
        onChange={(e) => onChangeAdvancedQuery(e)}
        value={selectedAdvancedQuery}
      >
        <Radio
          className={{ [styles.hidden]: options[0].any }}
          role="radio"
          aria-label={'anyRadio'}
          value="any"
        >
          Any
        </Radio>
        <Radio
          className={{ [styles.hidden]: options[0].anyipv4 }}
          value="ANYIPV4"
        >
          Any (IPv4)
        </Radio>
        <Radio className={{ [styles.hidden]: options[0].a }} value="A">
          A
        </Radio>
        <Radio className={{ [styles.hidden]: options[0].aaaa }} value="AAAA">
          AAAA
        </Radio>
        <Radio className={{ [styles.hidden]: options[0].cname }} value="CNAME">
          CNAME
        </Radio>
        <Radio className={{ [styles.hidden]: options[0].mx }} value="MX">
          MX
        </Radio>
        <Radio className={{ [styles.hidden]: options[0].ns }} value="NS">
          NS
        </Radio>
        <Radio className={{ [styles.hidden]: options[0].ptr4 }} value="PTR4">
          PTR4
        </Radio>
        <Radio className={{ [styles.hidden]: options[0].ptr6 }} value="PTR6">
          PTR6
        </Radio>
        <Radio className={{ [styles.hidden]: options[0].txt }} value="TXT">
          TXT
        </Radio>
        <Radio className={{ [styles.hidden]: options[0].soa }} value="SOA">
          SOA
        </Radio>
        <Radio
          className={{ [styles.hidden]: options[0].anyipv6 }}
          value="ANYIPV6"
        >
          Any (IPv6)
        </Radio>
      </Radio.Group>

      <Title level={4} className={styles['sub-title']}>
        Answer (Reverse)
      </Title>
      <Radio.Group
        onChange={(e) => onChangeAdvancedAnswer(e)}
        value={selectedAdvancedAnswer}
      >
        <Radio
          className={{ [styles.hidden]: options[1].a }}
          role="radio1"
          value="A"
        >
          A
        </Radio>
        <Radio className={{ [styles.hidden]: options[1].aaaa }} value="AAAA">
          AAAA
        </Radio>
        <Radio className={{ [styles.hidden]: options[1].ptr4 }} value="PTR4">
          PTR4
        </Radio>
        <Radio className={{ [styles.hidden]: options[1].ptr6 }} value="PTR6">
          PTR6
        </Radio>
        <Radio className={{ [styles.hidden]: options[1].cname }} value="CNAME">
          CNAME
        </Radio>
        <Radio className={{ [styles.hidden]: options[1].mx }} value="MX">
          MX
        </Radio>
        <Radio className={{ [styles.hidden]: options[1].ns }} value="NS">
          NS
        </Radio>
        <Radio className={{ [styles.hidden]: options[1].txt }} value="TXT">
          TXT
        </Radio>
        <Radio className={{ [styles.hidden]: options[1].soa }} value="SOA">
          SOA
        </Radio>
        <Radio
          className={{ [styles.hidden]: options[1].mxhash }}
          value="MXHASH"
        >
          MXHASH
        </Radio>
        <Radio
          className={{ [styles.hidden]: options[1].nshash }}
          value="NSHASH"
        >
          NSHASH
        </Radio>
        <Radio
          className={{ [styles.hidden]: options[1].soahash }}
          value="SOAHASH"
        >
          SOAHASH
        </Radio>
        <Radio
          className={{ [styles.hidden]: options[1].txthash }}
          value="TXTHASH"
        >
          TXTHASH
        </Radio>
      </Radio.Group>

      <Button
        className={styles.clearSelection}
        onClick={() => {
          setSelectedAdvancedQuery(null);
          setSelectedAdvancedAnswer(null);
        }}
        disabled={!(selectedAdvancedQuery || selectedAdvancedAnswer)}
      >
        Clear Selection
      </Button>
    </div>
  );
}

export function SPQLPivotingActions({
  changeSPQLQuery,
  iocType,
  field,
  value,
  valueType,
  operators,
  ...props
}) {
  const items = [];
  if (operators?.length > 0) {
    items.push({
      key: 'spql-operations',
      label: (
        <div style={{ padding: '0 16px', width: 116, textAlign: 'center' }}>
          Add to Query
        </div>
      ),
      children: (
        <SPQLSupportedOperations
          changeSPQLQuery={changeSPQLQuery}
          field={field}
          value={value}
          valueType={valueType}
          operators={operators}
        />
      ),
    });
  }
  if (iocType === 'ipv4' || iocType === 'domain') {
    items.push({
      key: 'spql-pivoting',
      label: <div style={{ width: 150, textAlign: 'center' }}>Explore DNS</div>,
      children: <SPQLPivotingToExploreMenu value={value} iocType={iocType} />,
    });
  }

  return (
    <div style={{ background: '#213338', borderRadius: 8, width: 450 }}>
      <Tabs items={items} defaultActiveKey={items[0]} />
    </div>
  );
}

function SPQLSupportedOperations({
  changeSPQLQuery,
  field,
  value,
  valueType,
  operators,
  ...props
}) {
  const spqlQuery = useSelector(getSPQLQuery);

  return (
    <div style={{ background: '#213338', borderRadius: 8 }}>
      <Menu>
        {operators &&
          operators.map((operator, idx) => (
            <Menu.Item
              onClick={({ item, key, keyPath, domEvent }) => {
                let addToQuery = `${field} ${key} ${value}`;
                if (Array.isArray(value)) {
                  addToQuery = `${field} ${key} [${value
                    .map((v) => {
                      if (typeof v === 'string') {
                        return `"${v.replaceAll('*', '\\*')}"`;
                      }
                      return v;
                    })
                    .join(', ')}]`;
                } else if (
                  valueType === 'string' ||
                  valueType === 'datestring'
                ) {
                  addToQuery = `${field} ${key} "${value?.replaceAll(
                    '*',
                    '\\*',
                  )}"`;
                }
                let newSPQLQuery = spqlQuery;
                if (newSPQLQuery && newSPQLQuery.length > 0) {
                  newSPQLQuery += ` AND `;
                }
                newSPQLQuery = newSPQLQuery + addToQuery;
                changeSPQLQuery(newSPQLQuery);
                showNotification(
                  infoNotification({
                    statusCode: 100,
                    message: 'Added to query',
                  }),
                );
              }}
              key={operator}
            >
              {operator}
            </Menu.Item>
          ))}
      </Menu>
    </div>
  );
}

function SPQLExpandedRow({
  record,
  changeSPQLQuery,
  changeSPQLSelectedColumns,
  ...props
}) {
  if (!record) return null;
  const CopyIcon = (props) => <Icon component={copy_icon} {...props} />;
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    showNotification(
      infoNotification({
        statusCode: 100,
        message: 'Copied to clipboard',
      }),
    );
  };

  const domain = record.domain?.replaceAll('.', '[.]');
  const selectedColumns = useSelector(getSPQLSelectedColumns);
  const metadataFields = useSelector(getSPQLFieldsMetadata);
  const [isHovered, setIsHovered] = useState({});

  const rows = [];
  Object.keys(record).forEach((key) => {
    if (key === 'key') return;
    rows.push({ key: key, value: record[key] });
  });

  return (
    <div style={{ background: '#16262B' }}>
      <span className={styles['spql-expanded-row-header']}>
        Scan data view for {domain}
      </span>
      <SPInnerTable>
        <Table
          columns={[
            {
              title: <ColumnTitle columnName={'Scan Parameters'} />,
              width: 400,
              key: 'key',
              dataIndex: 'key',
              render: (text, record, index) => {
                const isColumnSelected = selectedColumns.includes(text);
                const style = {
                  marginLeft: isColumnSelected || isHovered[text] ? 16 : 32,
                  color: 'white',
                };
                return (
                  <div
                    onMouseLeave={() => {
                      setIsHovered((prevHovered) => {
                        const newHovered = { ...prevHovered };
                        newHovered[text] = false;
                        return newHovered;
                      });
                    }}
                    onMouseEnter={() => {
                      setIsHovered((prevHovered) => {
                        const newHovered = { ...prevHovered };
                        if (!record.value) return newHovered;
                        newHovered[text] = true;
                        return newHovered;
                      });
                    }}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    {isColumnSelected && (
                      <RemoveColumn
                        onClick={() => {
                          if (selectedColumns.length === MIN_SELECTED_COLUMNS) {
                            showNotification(
                              warningNotification({
                                statusCode: 400,
                                message: `You cannot have less than ${MIN_SELECTED_COLUMNS} columns in the table header`,
                              }),
                            );
                            return;
                          }
                          const columns = selectedColumns.filter(
                            (c) => c !== text,
                          );
                          changeSPQLSelectedColumns(columns);
                          showNotification(
                            infoNotification({
                              statusCode: 100,
                              message: 'Removed from table header',
                            }),
                          );
                        }}
                      />
                    )}
                    {!isColumnSelected && isHovered[text] && (
                      <AttachColumn
                        onClick={() => {
                          if (selectedColumns.length === MAX_SELECTED_COLUMNS) {
                            showNotification(
                              warningNotification({
                                statusCode: 400,
                                message: `You cannot have more than ${MAX_SELECTED_COLUMNS} columns in the table header`,
                              }),
                            );
                            return;
                          }
                          const columns = [...selectedColumns, text];
                          changeSPQLSelectedColumns(columns);
                          showNotification(
                            infoNotification({
                              statusCode: 100,
                              message: 'Added to table header',
                            }),
                          );
                        }}
                      />
                    )}
                    <div style={style}>{text}</div>
                  </div>
                );
              },
            },
            {
              title: <ColumnTitle columnName={'Value'} />,
              dataIndex: 'value',
              value: 'value',
              render: (text, record, index) => {
                const fieldMetadata =
                  record.key in metadataFields
                    ? metadataFields[record.key]
                    : null;
                if (Array.isArray(record.value)) {
                  const value = '[' + record.value.join(', ') + ']';
                  if (record.key === 'favicon_icons') {
                    return (
                      <div
                        style={{
                          marginLeft: 32,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {record.value.map((url, idx) => {
                          return (
                            <Image
                              key={idx}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                              width={23}
                              src={url}
                            />
                          );
                        })}
                      </div>
                    );
                  }
                  return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Button
                        onClick={() => handleCopy(value)}
                        ghost
                        style={{
                          border: 0,
                          color: 'white',
                          marginRight: 4,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                        icon={<CopyIcon style={{ fontSize: 16 }} />}
                      />
                      {fieldMetadata && (
                        <Dropdown
                          overlay={
                            <SPQLPivotingActions
                              changeSPQLQuery={changeSPQLQuery}
                              field={record.key}
                              value={record.value}
                              valueType={fieldMetadata.value_type}
                              operators={fieldMetadata.valid_operators}
                            />
                          }
                          trigger={['click']}
                        >
                          <Button
                            type="link"
                            style={{
                              textWrap: 'wrap',
                              height: 'fit-content',
                              padding: 0,
                              border: 0,
                              textAlign: 'left',
                            }}
                          >
                            {value}
                          </Button>
                        </Dropdown>
                      )}
                      {!fieldMetadata && (
                        <span style={{ width: '100%' }}>{value}</span>
                      )}
                    </div>
                  );
                }
                let value = text;
                if (typeof record.value === 'boolean') {
                  value = record.value.toString();
                }
                if (!value) return <div></div>;

                const iocType = parseType(value);
                const isIOCTypeValidForExplore =
                  iocType === 'ipv4' || iocType === 'domain';

                return (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button
                      onClick={() => handleCopy(text)}
                      ghost
                      style={{
                        border: 0,
                        color: 'white',
                        marginRight: 4,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                      icon={<CopyIcon style={{ fontSize: 16 }} />}
                    />
                    {(fieldMetadata || isIOCTypeValidForExplore) && (
                      <Dropdown
                        overlay={
                          <SPQLPivotingActions
                            iocType={iocType}
                            changeSPQLQuery={changeSPQLQuery}
                            field={record.key}
                            value={value}
                            valueType={fieldMetadata?.value_type}
                            operators={fieldMetadata?.valid_operators}
                          />
                        }
                        trigger={['click']}
                      >
                        <Button
                          type="link"
                          style={{
                            textWrap: 'wrap',
                            height: 'fit-content',
                            padding: 0,
                            border: 0,
                            textAlign: 'left',
                          }}
                        >
                          {value}
                        </Button>
                      </Dropdown>
                    )}
                    {!fieldMetadata && !isIOCTypeValidForExplore && (
                      <span style={{ width: '100%' }}>{value}</span>
                    )}
                  </div>
                );
              },
            },
          ]}
          dataSource={rows}
          pagination={{
            disabled: false,
            showSizeChanger: false,
            hideOnSinglePage: true,
            pageSize: 1000,
          }}
        />
      </SPInnerTable>
    </div>
  );
}

function SPQLPagination({ resultsMetadata, getDeepScan, ...props }) {
  const spqlQuery = useSelector(getSPQLQuery);
  const spqlSorting = useSelector(getSPQLSorting);
  const currentPage = useSelector(getSPQLCurrentPage);
  return (
    <Pagination
      style={{ display: 'flex', justifyContent: 'flex-end', margin: '16px 0' }}
      total={resultsMetadata?.results_total_at_least}
      defaultPageSize={100}
      current={currentPage}
      showSizeChanger={false}
      onChange={(page, pageSize) => {
        getDeepScan({
          query: spqlQuery,
          sort: spqlSorting,
          limit: pageSize,
          skip: (page - 1) * pageSize,
        });
      }}
    />
  );
}

export function SPQLResultTable({
  getDeepScan,
  changeSPQLQuery,
  changeSPQLSelectedColumns,
  data,
  resultsMetadata,
  ...props
}) {
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowExpanded, setRowExpanded] = useState([]);
  const columns = useSPQLColumns({
    rowExpanded,
    setRowExpanded,
    selectedRows,
    setSelectedRows,
  });
  const scanData = useGetScanData(data);
  const resultsLoading = useSelector(getSPQLLoading);
  const NoDataIcon = (props) => <Icon component={no_data_icon} {...props} />;
  useEffect(() => {
    if (resultsLoading === STATUS.LOADING) {
      setSelectedRows([]);
      setRowExpanded([]);
    }
  }, [resultsLoading]);

  return (
    <div style={props.style}>
      {resultsLoading === STATUS.LOADING && (
        <LoadingSilentPush size={80} positionCenter />
      )}
      {resultsLoading === STATUS.SUCCESS && (
        <>
          <SPQLPagination
            resultsMetadata={resultsMetadata}
            getDeepScan={getDeepScan}
          />
          <SPCheckbox>
            <Table
              locale={{
                emptyText:
                  resultsLoading === STATUS.SUCCESS &&
                  scanData?.length === 0 ? (
                    <div>
                      <NoDataIcon style={{ fontSize: 32, marginTop: 8 }} />
                      <Title style={{ color: 'white' }} level={4}>
                        Query didn't yield any results
                      </Title>
                      <Text>Change query</Text>
                    </div>
                  ) : (
                    <div></div>
                  ),
              }}
              title={() => (
                <SPQLTableHeader
                  scanData={scanData}
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                  changeSPQLSelectedColumns={changeSPQLSelectedColumns}
                  resultsMetadata={resultsMetadata}
                />
              )}
              pagination={{
                disabled: false,
                showSizeChanger: false,
                hideOnSinglePage: true,
                pageSize: 1000,
              }}
              dataSource={scanData}
              columns={columns}
              scroll={{ x: 1500, y: 1000 }}
              expandable={{
                expandedRowRender: (record) => (
                  <SPQLExpandedRow
                    changeSPQLSelectedColumns={changeSPQLSelectedColumns}
                    changeSPQLQuery={changeSPQLQuery}
                    record={record}
                  />
                ),
                expandIconColumnIndex: columns.length,
                expandedRowKeys: rowExpanded,
                expandIcon: ({ expanded, onExpand, record }) => (
                  <Space>
                    <Typography.Link
                      onClick={() => {
                        if (expanded) {
                          setRowExpanded([]);
                          return;
                        }
                        setRowExpanded([record.key]);
                      }}
                    >
                      {expanded ? 'Collapse' : 'Expand'}
                    </Typography.Link>
                  </Space>
                ),
                columnWidth: 100,
                fixed: 'right',
              }}
            />
          </SPCheckbox>
          <SPQLPagination
            resultsMetadata={resultsMetadata}
            getDeepScan={getDeepScan}
          />
        </>
      )}
    </div>
  );
}
